import './PrivacyPageStyle.css';
import React from 'react';

class PrivacyPolicyPage extends React.Component {
    render() {
        return (
            <div className={'privacyPage'}>
                <h3>Privacy Policy</h3>
                <p>
                    Wisene WATCH is an application for receiving notifications from the WISENE Roof Monitoring. <br/>
                    This page is used to inform visitors regarding our policies with the collection,
                    use, and disclosure of Personal Information if anyone decided to use our Service.
                </p>
                <p className={'header'}><b>Information Collection and Use</b></p>
                <p>
                    The application does not collect or store personal data. <br/>

                    It does however use third party services that may collect information used to identify you. <br/>

                    Links to privacy policies of third party service providers used by the app: <br/>
                    <a href={'https://policies.google.com/privacy'}>Google Play Services</a> <br/>
                    <a href={'https://firebase.google.com/support/privacy'}>Firebase</a> <br/>
                </p>
                <p className={'header'}><b>Children’s Privacy</b></p>
                <p>
                    These Services do not address anyone under the age of 13.
                </p>
                <p className={'header'}><b>Changes to This Privacy Policy</b></p>
                <p>
                    We may update our Privacy Policy from time to time. Thus, you are advised to review this page
                    periodically for any changes. <br/>
                    We will notify you of any changes by posting the new Privacy Policy on this page. These changes are
                    effective immediately after they are posted on this page.
                </p>
            </div>
        );
    }
}
export default PrivacyPolicyPage;